module.exports = __webpack_public_path__ + "static/media/foto3.cea93658.png";